// firebase.js (v9 Modular)

import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';


const defaultConfig = {
  apiKey: "AIzaSyDshSaubShlzlFUTlCbAnK87hNO50JD3q0",
  authDomain: "hearingaid-1655f.firebaseapp.com",
  projectId: "hearingaid-1655f",
  storageBucket: "hearingaid-1655f.appspot.com",
  messagingSenderId: "888766538563",
  appId: "1:888766538563:web:a578d574bf160c01cac5f6",
  measurementId: "G-3ZH1PVJX6V"
};

// Initialize Firebase App
const defaultApp = initializeApp(defaultConfig);

// 환경변수에서 DB 이름 불러오기
const defaultDbName = process.env.REACT_APP_FIRESTORE_DEFAULT_DB;
const kioskDbName = process.env.REACT_APP_FIRESTORE_KIOSK_DB;

// Initialize Services
const defaultDB = getFirestore(defaultApp, defaultDbName);
const storage = getStorage(defaultApp);
const functions = getFunctions(defaultApp);
const auth = getAuth(defaultApp);
const kioskDB = getFirestore(defaultApp, kioskDbName);

// ── Functions 에뮬레이터 연결 (dev 모드 + 명시적 플래그 둘 다 필요) ─────────────
// 이중 안전장치: prod 빌드(NODE_ENV !== 'development')에서는 어떤 경우에도 에뮬레이터 안 잡힘.
// 사용 시: 별도 터미널에서 `cd functions_v2 && firebase emulators:start --only functions:v2`
const shouldUseFunctionsEmulator =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true';

if (shouldUseFunctionsEmulator) {
  const host = process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || '127.0.0.1';
  const port = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT) || 5100;
  try {
    connectFunctionsEmulator(functions, host, port);
    // eslint-disable-next-line no-console
    console.info(`[firebase] Functions emulator connected → http://${host}:${port}`);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[firebase] Functions emulator 연결 실패. 에뮬레이터가 실행 중인지 확인하세요.', e);
  }
}

// Set Persistence (NOTE: should be awaited before login, e.g., in login logic)
// const authPersistence = auth.setPersistence(browserLocalPersistence);
const authPersistence = () => setPersistence(auth, browserLocalPersistence);

// const firestore = firebase.firestore();
// const auth = firebase.auth();
// const storage = firebase.storage();
// const authPersistence = firebase.auth.Auth.Persistence;
// const functions = firebase.functions();

//firestore.useEmulator(“127.0.0.1”, 9090);
//functions.useEmulator(“127.0.0.1", 9190);

//export { firebaseApp, firestore, auth, storage, authPersistence, functions };
export { defaultApp, defaultDB, kioskDB, auth, storage, authPersistence, functions };